module.exports = __webpack_public_path__ + "img/luke-matt-image.75d3b562.png";